import { call, put, select } from 'redux-saga/effects';
import { disableMfaFailure, disableMfaSuccess } from '../actions';
import { disableMfa } from '../api';
import { ApiError, ApiResponse } from 'store/api/types';
import { MessageData } from 'store/app/types';
import { MessageStates } from 'containers/MessageBox';
import { turnMessageOn, turnModalOff } from 'store/app/actions';
import { checkResponse } from 'store/utils';
import { fetchMeRequest } from 'store/auth/actions';
import { getAuthUser } from 'store/auth/selectors';
import { DisableMfaRequestAction } from 'store/account/types';
import { logoutRequest } from 'store/auth/actions';
import { renderErrorMessage } from 'utils/render-error-message';
import { fetchUsersRequest } from 'store/user/actions';
import i18n from 'i18next';

/* eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types */
export function* disableMfaSaga(action: DisableMfaRequestAction) {
  try {
    let err: ApiError | null;

    const { userId } = action.payload;
    const response: ApiResponse = yield call(disableMfa, userId);

    err = checkResponse(response?.responseMessage);
    if (err) throw err;

    const message: MessageData = {
      title: i18n.t('notifications.disabled'),
      description: i18n.t('notifications.mfa-disabled-successfully'),
      type: MessageStates.SUCCESS,
    };
    yield put(turnMessageOn(message));
    yield put(disableMfaSuccess());
    
    // Check if disabling for current user or another user
    const currentUser = yield select(getAuthUser);
    if (userId === currentUser?.userUuid) {
      yield put(fetchMeRequest());
    } else {
      // If disabling for another user, fetch users list to update the selectedAccount
      yield put(fetchUsersRequest());
    }
    
    yield put(turnModalOff());
  } catch (error: any) {
    const message: MessageData | null = renderErrorMessage(error);
    if (message) {
      yield put(turnMessageOn(message));
    } else {
      yield put(logoutRequest());
    }
    yield put(disableMfaFailure());
  }
}
